import type { DynamicRecord } from '../../../types/api';
import type { FilePointer, FormFieldValue } from '../../../types/forms';

const isFilePointer = (value: unknown): value is FilePointer => {
  if (!value || typeof value !== 'object') return false;
  const pointer = value as Partial<FilePointer>;
  return typeof pointer.id === 'number' && typeof pointer.filename === 'string' &&
    typeof pointer.size === 'number' && typeof pointer.mime_type === 'string';
};

// Type guard to check if a value is a FormFieldValue
export const isFormFieldValue = (value: any): value is FormFieldValue => {
  return (
    value === null ||
    value === undefined ||
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean' ||
    value instanceof Date ||
    (Array.isArray(value) && value.every(item =>
      typeof item === 'string' || typeof item === 'number' || isFilePointer(item)
    ))
  );
};

// Helper function to safely convert DynamicRecord | FormFieldValue to FormFieldValue
export const toFormFieldValue = (value: DynamicRecord | FormFieldValue): FormFieldValue => {
  if (isFormFieldValue(value)) {
    return value;
  }
  // If it's a DynamicRecord, extract the id for relationship fields
  if (value && typeof value === 'object' && 'id' in value) {
    return value.id as FormFieldValue;
  }
  return null;
};
